<template>
  <span :class="$style.badge">
    {{ label }}
    <HgIcon v-bind="{ icon: 'Cross' }" size="x-small" theme="dark" @click="emit('removeClicked')" />
  </span>
</template>

<script setup lang="ts">
import { HgIcon } from '@smg-real-estate/domus';

interface Props {
  /** Selected Location. */
  label: string;
}

defineProps<Props>();

const emit = defineEmits<{
  removeClicked: [];
}>();
</script>

<style lang="scss" module>
@use '@/assets/variables' as *;

.badge {
  padding: 0.2rem 0.4rem;
  color: $color-grey-90;
  background-color: $color-grey-30;
  border-radius: $border-radius;

  @include font-regular;
  @include body-3;

  svg {
    cursor: pointer;
  }
}
</style>
